import './App.css';
import AppLayout from './views/AppLayout';
import LoginPage from './views/LoginPage';
import { MsalProvider } from '@azure/msal-react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AppProvider } from './views/AppContext';
import UnauthorizedPage from './views/UnauthorizedPage';

function App({ msalInstance }) {
    return (
        <AppProvider>
            <MsalProvider instance={msalInstance}>
                <Router>
                    <Routes>
                        <Route path="/" element={<LoginPage />} />
                        <Route path="/home" element={<AppLayout />} />
                        <Route path="/unauthorized" element={<UnauthorizedPage />} />
                    </Routes>
                </Router>
            </MsalProvider>
        </AppProvider>

    );

}



export default App;
